function initCarousels() {
  document.querySelectorAll('[data-carousel]').forEach(carousel => {
    if (carousel.dataset.initialized) {
      return;
    }

    const images = carousel.querySelectorAll('.carousel__image');
    const prevBtn = carousel.querySelector('.carousel__btn--prev');
    const nextBtn = carousel.querySelector('.carousel__btn--next');

    if (!prevBtn || !nextBtn || images.length < 2) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    } 

    carousel.dataset.initialized = true;
  });
}

document.addEventListener('DOMContentLoaded', initCarousels);
document.addEventListener('shopify:section:load', initCarousels);

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.carousel__btn');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  if (btn.classList.contains('is-disabled')) return;

  const carousel = btn.closest('[data-carousel]');
  if (!carousel) return;

  const images = carousel.querySelectorAll('.carousel__image');
  const prevBtn = carousel.querySelector('.carousel__btn--prev');
  const nextBtn = carousel.querySelector('.carousel__btn--next');
  
  if (images.length < 2) return;

  let currentIndex = 0;
  images.forEach((img, index) => {
    if (img.classList.contains('is-active')) {
      currentIndex = index;
    }
  });

  if (btn.classList.contains('carousel__btn--prev') && currentIndex > 0) {
    currentIndex--;
  } else if (btn.classList.contains('carousel__btn--next') && currentIndex < images.length - 1) {
    currentIndex++;
  }

  images.forEach((img, index) => {
    if (index === currentIndex) {
      img.classList.add('is-active');
    } else {
      img.classList.remove('is-active');
    }
  });

  if (currentIndex === 0) {
    prevBtn.classList.add('is-disabled');
  } else {
    prevBtn.classList.remove('is-disabled');
  }

  if (currentIndex === images.length - 1) {
    nextBtn.classList.add('is-disabled');
  } else {
    nextBtn.classList.remove('is-disabled');
  }
});
